import { fmtRelative } from "../lib/format";

interface Props {
  updatedAt: string | null;
  isFetching: boolean;
  cached: boolean;
  onRefresh: () => void;
}

export function RefreshControl({ updatedAt, isFetching, cached, onRefresh }: Props) {
  return (
    <div className="flex items-center gap-3 text-sm">
      <div className="hidden sm:flex flex-col items-end leading-tight">
        <span className="text-xs text-slate-500 dark:text-slate-400">Letzter Stand</span>
        <span className="font-mono text-xs">
          {fmtRelative(updatedAt)}
          {cached ? " · cached" : ""}
        </span>
      </div>
      <button
        type="button"
        onClick={onRefresh}
        disabled={isFetching}
        className="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-3 py-1.5 text-white text-sm font-medium shadow-sm hover:bg-slate-800 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200 transition"
      >
        <RefreshIcon spinning={isFetching} />
        <span className="hidden sm:inline">{isFetching ? "Aktualisiere…" : "Aktualisieren"}</span>
      </button>
    </div>
  );
}

function RefreshIcon({ spinning }: { spinning: boolean }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={spinning ? "animate-spin" : ""}
      aria-hidden="true"
    >
      <path d="M3 12a9 9 0 0 1 15.5-6.36L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-15.5 6.36L3 16" />
      <path d="M3 21v-5h5" />
    </svg>
  );
}
